module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori4-15a3117b80ba76bde7881b1d3d112313.jpg";